import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20" aria-label="用户口碑">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="用户口碑"
          title="瓜友们怎么说"
          desc="以下评价来自长期使用推荐名单的瓜友，我们保留了他们最真实的使用感受。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.id}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-double-quotes-l"></i>
              </span>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="h-10 w-10 shrink-0 overflow-hidden rounded-full bg-background-100">
                  <img
                    src={item.avatar}
                    alt={`${item.name}的头像`}
                    className="h-full w-full object-cover object-top"
                  />
                </span>
                <span className="min-w-0">
                  <span className="block truncate font-label text-sm font-medium text-foreground-900">
                    {item.name}
                  </span>
                  <span className="block truncate text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}